import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BASE_WS_URL } from '../config/config';
import { connect, disconnect } from '../store/slices/socketSlice';

export default function useGameSocket(gameId) {
  const dispatch = useDispatch();
  const { lastMessage, status } = useSelector((s) => s.socket);

  const [smoothData, setSmoothData] = useState(null);
  const rafRef = useRef(null);
  const wasBackgroundedRef = useRef(false);


  const connectSocket = () => {
    if (!gameId) return;
    const socketUrl = `${BASE_WS_URL}/betting?gameId=${gameId}`;
    dispatch(connect(socketUrl));
  };

  useEffect(() => {
    connectSocket();
    return () => {
      dispatch(disconnect());
    };
  }, [dispatch, gameId]);


  useEffect(() => {
    if (lastMessage == null) return; 

    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      setSmoothData((prev) => ({
        ...prev,
        ...lastMessage,
      }));
    });

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [lastMessage]);

  
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        wasBackgroundedRef.current = true;
      } else if (document.visibilityState === 'visible') {
        if (wasBackgroundedRef.current) {
          wasBackgroundedRef.current = false;

          
          dispatch(disconnect());
          connectSocket();
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [gameId]);

  return { socketData: smoothData, connected: status === 'connected' };
}